

export const WorkoutHelpers = {

  triggerDefaultEvent(name, detail) {
    const event = new CustomEvent(name, { detail });
    window.dispatchEvent(event);
  },

  getPattern(key){
    const value = localStorage.getItem("common-"+key) || 0
    if(value) return parseInt(value)
    return value
  }
}


